/**
 * --------------------------------------------------
 * !!! THIS FILE WAS GENERATED BY GRAPHQL-CODEGEN !!!
 * !!!   DO NOT MODIFY THIS FILE BY YOURSELF      !!!
 * --------------------------------------------------
 */

import * as c from "@hex/common";
import type * as Types from "../../generated/graphqlTypes";

import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type MagicDescribeProjectQueryVariables = Types.Exact<{
  hexVersionId: Types.Scalars["HexVersionId"]["input"];
}>;

export type MagicDescribeProjectQuery = {
  readonly __typename: "Query";
  readonly magicDescribeProject: {
    readonly __typename: "StreamingEditResult";
    readonly magicEventId: c.MagicEventId | null;
    readonly responseOverride: string | null;
  };
};

export const MagicDescribeProjectDocument = /*#__PURE__*/ gql`
  query MagicDescribeProject($hexVersionId: HexVersionId!) {
    magicDescribeProject(hexVersionId: $hexVersionId) {
      magicEventId
      responseOverride
    }
  }
`;

/**
 * __useMagicDescribeProjectQuery__
 *
 * To run a query within a React component, call `useMagicDescribeProjectQuery` and pass it any options that fit your needs.
 * When your component renders, `useMagicDescribeProjectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMagicDescribeProjectQuery({
 *   variables: {
 *      hexVersionId: // value for 'hexVersionId'
 *   },
 * });
 */
export function useMagicDescribeProjectQuery(
  baseOptions: Apollo.QueryHookOptions<
    MagicDescribeProjectQuery,
    MagicDescribeProjectQueryVariables
  > &
    (
      | { variables: MagicDescribeProjectQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    MagicDescribeProjectQuery,
    MagicDescribeProjectQueryVariables
  >(MagicDescribeProjectDocument, options);
}
export function useMagicDescribeProjectLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    MagicDescribeProjectQuery,
    MagicDescribeProjectQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    MagicDescribeProjectQuery,
    MagicDescribeProjectQueryVariables
  >(MagicDescribeProjectDocument, options);
}
export function useMagicDescribeProjectSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    MagicDescribeProjectQuery,
    MagicDescribeProjectQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    MagicDescribeProjectQuery,
    MagicDescribeProjectQueryVariables
  >(MagicDescribeProjectDocument, options);
}
export type MagicDescribeProjectQueryHookResult = ReturnType<
  typeof useMagicDescribeProjectQuery
>;
export type MagicDescribeProjectLazyQueryHookResult = ReturnType<
  typeof useMagicDescribeProjectLazyQuery
>;
export type MagicDescribeProjectSuspenseQueryHookResult = ReturnType<
  typeof useMagicDescribeProjectSuspenseQuery
>;
export type MagicDescribeProjectQueryResult = Apollo.QueryResult<
  MagicDescribeProjectQuery,
  MagicDescribeProjectQueryVariables
>;
